import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainNavbar from './Navbar';
import Header from './Component/Helmet';
import './custom-styles.scss';

// Code-splitting per trasa: użytkownik wchodzący prosto na /results/... nie
// powinien ściągać kodu strony głównej, kar czy listy startowej.
const Home = lazy(() => import('./Home'));
const About = lazy(() => import('./About'));
const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const PrivacyPolicyApp = lazy(() => import('./PrivacyPolicyApp'));
const Results = lazy(() => import('./Results'));
const ApiPage = lazy(() => import('./ApiPage'));
const PagePenalties = lazy(() => import('./Penalties'));
const StartListPage = lazy(() => import('./features/startList/StartListPage'));

const RouteFallback = () => <div className="loading-spinner" />;

const App = () => {
  return (
    <Router>
      <div>
      <Header />
        <Routes>
          <Route path="/about" element={<MainNavbar showAllMenu={false} />} />
          <Route path="/penalties/*" element={<MainNavbar showAllMenu={true} />} />
          {/* <Route path="/results/*" element={<MainNavbar showAllMenu={true} />} />*/}
       {/*   <Route path="/" element={<MainNavbar showAllMenu={true} />} />*/}
          <Route path="/api" element={<MainNavbar showAllMenu={true} />} />
        </Routes>

        {/* Render different components based on the route */}
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy/app" element={<PrivacyPolicyApp />} />
            <Route path="/penalties/:eventID" element={<PagePenalties />} /> {/* Pass the eventID param */}
            <Route path="/results/:EventID" element={<Results />} />
            <Route path="/start-list/:EventID" element={<StartListPage />} />
            <Route path="/" element={<Home />} />
            <Route path="/api" element={<ApiPage />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
